import { LOCATION_CHANGE } from '../../../../../shared/frontend/libs/router/redux-store';
import {
  SET_KEYSTONE_TEAM_HISTORY,
  SHOW_KEYSTONE_TEAM_HISTORY_LOADING_SPINNER
} from '../actions/keystoneTeamHistoryActions';
import { TKeystoneTeamHistoryClientState } from '../libs/store';
import { TAction } from '../../../../../shared/frontend/scripts/actions/types/action';

const initialState: TKeystoneTeamHistoryClientState = {
  isLoading: false,
  history: [],
  isLoaded: false
};

const keystoneTeamReducer = (
  state: TKeystoneTeamHistoryClientState = initialState,
  action: TAction<any>
): Partial<TKeystoneTeamHistoryClientState> => {
  switch (action.type) {
    case SHOW_KEYSTONE_TEAM_HISTORY_LOADING_SPINNER: {
      return {
        ...state,
        isLoading: action.payload,
        isLoaded: !action.payload
      };
    }
    case SET_KEYSTONE_TEAM_HISTORY: {
      return {
        ...state,
        history: action.payload
      };
    }
    case LOCATION_CHANGE: {
      return initialState;
    }
    default: {
      return state;
    }
  }
};

export default keystoneTeamReducer;
